import { AppIconButton } from "../../../../../shared/components/AppIconButton";
import { SidebarCloseIcon } from "../../../../../shared/icons/SidebarCloseIcon";
import { SidebarOpenIcon } from "../../../../../shared/icons/SidebarOpenIcon";
import styles from "./styles.module.css";

interface Props {
  isSidebarOpen: boolean;
  handleSidebarLayoutControl: () => void;
  className?: string;
}

export const SidebarLayoutButton = ({
  isSidebarOpen,
  handleSidebarLayoutControl,
  className,
}: Props) => {
  return (
    <AppIconButton
      onClick={handleSidebarLayoutControl}
      className={!isSidebarOpen ? styles["sidebar-open"] : ""}
    >
      {isSidebarOpen ? <SidebarCloseIcon /> : <SidebarOpenIcon />}
    </AppIconButton>
  );
};
